import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { UserRole } from '../models/enums';

/**
 * Factory de Guardia de Roles Funcional.
 * Verifica si el usuario autenticado tiene uno de los roles permitidos.
 * @param allowedRoles Array de roles autorizados para acceder a la ruta.
 */
export const roleGuard = (allowedRoles: UserRole[]): CanActivateFn => {
    return () => {
        const authService = inject(AuthService);
        const router = inject(Router);
        const userRole = authService.userRole();

        // 1. Si no hay rol definido aún (inicializando), bloqueamos o esperamos.
        // Como authGuard debería ejecutarse primero, el rol debería ser al menos null si no hay sesión.
        if (!userRole) {
            return router.createUrlTree(['/auth/login']);
        }

        // 2. Verificar si el rol actual está en la lista de permitidos
        const hasRole = allowedRoles.includes(userRole);

        if (hasRole) {
            return true;
        }

        // 3. No autorizado: Redirigir basado en el rol o a un dashboard por defecto
        // 3. No autorizado: Redirigir basado en el rol o a un dashboard por defecto
        if (userRole === UserRole.SUPERADMIN) return router.createUrlTree(['/business']);
        if (userRole === UserRole.OWNER || userRole === UserRole.ADMIN) return router.createUrlTree(['/admin/dashboard']);
        if (userRole === UserRole.POS) return router.createUrlTree(['/finance/cash/daily']);
        if (userRole === UserRole.RESOURCE || userRole === UserRole.USER) return router.createUrlTree(['/dashboard']);

        return router.createUrlTree(['/']);
    };
};
